import { useEffect } from "react";

// Call onOutside when the user clicks outside the ref'd element while active.
export default function useClickOutside(ref, active, onOutside) {
  useEffect(() => {
    if (!active) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onOutside();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [ref, active, onOutside]);
}
